export const LIST_HEADERS = [
  "task_id",
  "task_name",
  "status",
  "event",
  "traceback",
  "date_created",
];
